export const contactTranslations = {
  en: {
    hero: {
      home: 'Home',
      contact: 'Contact',
      heading: 'Get in Touch',
      subheading: "Let's Plan Your Perfect Training Camp",
      tagline: 'Our team is ready to help you organize an unforgettable sports experience',
    },
    methods: {
      heading: 'How Can We Help You?',
      callUs: 'Call Us',
      hours1: 'Monday - Friday: 9:00 AM - 6:00 PM',
      hours2: 'Saturday: 10:00 AM - 2:00 PM',
      callNow: 'Call Now',
      emailUs: 'Email Us',
      respond24: "We'll respond within 24 hours",
      sendEmail: 'Send Email',
      visitUs: 'Visit Us',
      sofiaBulgaria: 'Sofia, Bulgaria',
      byAppointment: 'By appointment only',
      getDirections: 'Get Directions',
    },
    form: {
      heading: 'Send Us a Message',
      subheading: "Fill out the form below and we'll get back to you shortly",
      successMessage: "Thank you! Your message has been sent successfully. We'll get back to you soon.",
      fullName: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number',
      organization: 'Organization/Team',
      sport: 'Sport Interest',
      location: 'Preferred Location',
      participants: 'Number of Participants',
      dates: 'Preferred Dates',
      message: 'Message',
      hearAbout: 'How did you hear about us?',
      placeholderName: 'Your full name',
      placeholderEmail: 'your.email@example.com',
      placeholderPhone: '+359 ...',
      placeholderOrg: 'Your club or organization name',
      placeholderParticipants: 'Estimated number of athletes',
      placeholderDates: 'e.g., June 15-30, 2026',
      placeholderMessage: 'Tell us about your training camp requirements, goals, and any specific needs...',
      selectSport: 'Select a sport...',
      selectLocation: 'Select location...',
      selectHearAbout: 'Please select...',
      sportOptions: ['Basketball', 'Volleyball', 'Swimming', 'Water Polo', 'Athletics', 'Football', 'Multi-Sport Camp', 'Other'],
      locationOptions: ['Sofia - Mladost', 'Sofia - NSA', 'Sofia - Boyana', 'Plovdiv', 'Kranevo', 'Not sure yet'],
      hearAboutOptions: ['Google Search', 'Social Media', 'Referral', 'Previous Client', 'Sports Organization', 'Other'],
      sending: 'Sending...',
      sendMessage: 'Send Message',
      requiredNote: 'All fields marked with * are required',
      errorFullName: 'Please enter your full name',
      errorEmail: 'Please enter your email address',
      errorEmailInvalid: 'Please enter a valid email address',
      errorSport: 'Please select a sport',
      errorMessage: 'Please enter your message',
    },
    infoCards: {
      officeHours: 'Office Hours',
      mondayFriday: 'Monday - Friday: 9:00 AM - 6:00 PM',
      saturday: 'Saturday: 10:00 AM - 2:00 PM',
      sundayClosed: 'Sunday: Closed',
      quickResponse: 'Quick Response',
      quickResponseText: 'We typically respond to all inquiries within 24 hours during business days.',
      languages: 'Languages',
      langList: ['English', 'Bulgarian', 'Russian', 'German'],
      urgentInquiries: 'Urgent Inquiries',
      urgentText: 'For urgent matters, please call us directly at',
    },
    map: { heading: 'Find Us in Sofia' },
    faq: {
      heading: 'Frequently Asked Questions',
      subheading: 'Quick answers to common questions',
      items: [
        { question: 'How quickly will I receive a response?', answer: 'We aim to respond to all inquiries within 24 hours during business days. For urgent matters, please call us directly.' },
        { question: 'What information should I include in my inquiry?', answer: 'Please provide details about your sport, number of participants, preferred dates, location preferences, and any specific requirements for your training camp.' },
        { question: 'Can I schedule a call or video meeting?', answer: "Absolutely! Mention your preferred time in the message form, and we'll arrange a call or video consultation to discuss your needs in detail." },
        { question: 'Do you offer facility tours?', answer: 'Yes, we can arrange tours of our facilities in Sofia, Plovdiv, and Kranevo. Please contact us to schedule a visit.' },
        { question: 'What languages do you speak?', answer: 'Our team is fluent in English, Bulgarian, Russian, and German. We can accommodate communication in other languages upon request.' },
        { question: 'Is there a minimum group size?', answer: 'We work with teams of all sizes, from small groups to large international delegations. Contact us to discuss your specific needs.' },
      ],
    },
    social: {
      heading: 'Connect With Us',
      subheading: 'Follow our latest updates and training camp highlights',
    },
    testimonials: {
      heading: 'What Our Clients Say',
      items: [
        { quote: 'The team at Champion Maker was incredibly responsive and helpful in organizing our basketball training camp in Sofia. Everything was perfectly arranged!', name: 'Coach Michael Roberts', organization: 'London Basketball Academy' },
        { quote: 'Excellent communication from start to finish. They answered all our questions and made the entire process smooth and stress-free.', name: 'Sarah Thompson', organization: 'Manchester Swimming Club' },
        { quote: 'Quick responses, professional service, and great attention to detail. Highly recommend for any team planning a training camp in Bulgaria.', name: 'Andreas Mueller', organization: 'Berlin Volleyball Team' },
      ],
    },
    cta: {
      heading: 'Ready to Start Planning?',
      text: "Let's create an exceptional training experience for your team",
      viewPackages: 'View Our Packages',
      scheduleCall: 'Schedule a Call',
    },
  },
  ar: {
    hero: {
      home: 'الرئيسية',
      contact: 'اتصل بنا',
      heading: 'تواصل معنا',
      subheading: 'لنخطط لمعسكر التدريب المثالي لك',
      tagline: 'فريقنا جاهز لمساعدتك في تنظيم تجربة رياضية لا تُنسى',
    },
    methods: {
      heading: 'كيف يمكننا مساعدتك؟',
      callUs: 'اتصل بنا',
      hours1: 'الإثنين - الجمعة: 9:00 ص - 6:00 م',
      hours2: 'السبت: 10:00 ص - 2:00 م',
      callNow: 'اتصل الآن',
      emailUs: 'راسلنا',
      respond24: 'سنرد خلال 24 ساعة',
      sendEmail: 'إرسال بريد',
      visitUs: 'زرنا',
      sofiaBulgaria: 'صوفيا، بلغاريا',
      byAppointment: 'بموعد فقط',
      getDirections: 'احصل على الاتجاهات',
    },
    form: {
      heading: 'أرسل لنا رسالة',
      subheading: 'املأ النموذج أدناه وسنرد عليك قريبًا',
      successMessage: 'شكرًا! تم إرسال رسالتك بنجاح. سنرد عليك قريبًا.',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'رقم الهاتف',
      organization: 'المنظمة/الفريق',
      sport: 'الرياضة',
      location: 'الموقع المفضل',
      participants: 'عدد المشاركين',
      dates: 'التواريخ المفضلة',
      message: 'الرسالة',
      hearAbout: 'كيف سمعت عنا؟',
      placeholderName: 'اسمك الكامل',
      placeholderEmail: 'your.email@example.com',
      placeholderPhone: '+359 ...',
      placeholderOrg: 'اسم ناديك أو منظمتك',
      placeholderParticipants: 'العدد التقريبي للرياضيين',
      placeholderDates: 'مثال: 15-30 يونيو 2026',
      placeholderMessage: 'أخبرنا عن متطلبات معسكر التدريب وأهدافك وأي احتياجات خاصة...',
      selectSport: 'اختر رياضة...',
      selectLocation: 'اختر موقعًا...',
      selectHearAbout: 'اختر...',
      sportOptions: ['كرة السلة', 'الكرة الطائرة', 'السباحة', 'كرة الماء', 'ألعاب القوى', 'كرة القدم', 'معسكر متعدد الرياضات', 'أخرى'],
      locationOptions: ['صوفيا - ملادوست', 'صوفيا - الأكاديمية الوطنية', 'صوفيا - بويانا', 'بلوفديف', 'كرانييفو', 'غير متأكد بعد'],
      hearAboutOptions: ['بحث جوجل', 'وسائل التواصل', 'إحالة', 'عميل سابق', 'منظمة رياضية', 'أخرى'],
      sending: 'جاري الإرسال...',
      sendMessage: 'إرسال الرسالة',
      requiredNote: 'جميع الحقول المميزة بـ * مطلوبة',
      errorFullName: 'يرجى إدخال اسمك الكامل',
      errorEmail: 'يرجى إدخال بريدك الإلكتروني',
      errorEmailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
      errorSport: 'يرجى اختيار رياضة',
      errorMessage: 'يرجى إدخال رسالتك',
    },
    infoCards: {
      officeHours: 'ساعات العمل',
      mondayFriday: 'الإثنين - الجمعة: 9:00 ص - 6:00 م',
      saturday: 'السبت: 10:00 ص - 2:00 م',
      sundayClosed: 'الأحد: مغلق',
      quickResponse: 'رد سريع',
      quickResponseText: 'نرد عادة على جميع الاستفسارات خلال 24 ساعة في أيام العمل.',
      languages: 'اللغات',
      langList: ['الإنجليزية', 'البلغارية', 'الروسية', 'الألمانية'],
      urgentInquiries: 'استفسارات عاجلة',
      urgentText: 'للأمور العاجلة، يرجى الاتصال بنا مباشرة على',
    },
    map: { heading: 'اعثر علينا في صوفيا' },
    faq: {
      heading: 'الأسئلة الشائعة',
      subheading: 'إجابات سريعة على الأسئلة الشائعة',
      items: [
        { question: 'ما مدى سرعة الرد على استفساري؟', answer: 'نسعى للرد على جميع الاستفسارات خلال 24 ساعة في أيام العمل. للأمور العاجلة، يرجى الاتصال بنا مباشرة.' },
        { question: 'ما المعلومات التي يجب تضمينها في استفساري؟', answer: 'يرجى تقديم تفاصيل عن رياضتك وعدد المشاركين والتواريخ المفضلة وتفضيلات الموقع وأي متطلبات خاصة لمعسكر التدريب.' },
        { question: 'هل يمكنني حجز مكالمة أو لقاء فيديو؟', answer: 'بالتأكيد! اذكر الوقت المفضل في نموذج الرسالة، وسنرتب مكالمة أو استشارة فيديو لمناقشة احتياجاتك بالتفصيل.' },
        { question: 'هل تقدمون جولات في المرافق؟', answer: 'نعم، يمكننا ترتيب جولات في مرافقنا في صوفيا وبلوفديف وكرانييفو. يرجى الاتصال بنا لجدولة زيارة.' },
        { question: 'ما اللغات التي تتحدثونها؟', answer: 'فريقنا يتقن الإنجليزية والبلغارية والروسية والألمانية. يمكننا استيعاب التواصل بلغات أخرى عند الطلب.' },
        { question: 'هل هناك حد أدنى لحجم المجموعة؟', answer: 'نعمل مع فرق من جميع الأحجام، من المجموعات الصغيرة إلى الوفود الدولية الكبيرة. اتصل بنا لمناقشة احتياجاتك المحددة.' },
      ],
    },
    social: {
      heading: 'تواصل معنا',
      subheading: 'تابع آخر أخبارنا وملخصات معسكرات التدريب',
    },
    testimonials: {
      heading: 'ماذا يقول عملاؤنا',
      items: [
        { quote: 'كان فريق صناع الأبطال سريع الاستجابة ومساعدًا جدًا في تنظيم معسكر تدريب كرة السلة في صوفيا. كل شيء كان منظمًا بشكل مثالي!', name: 'Coach Michael Roberts', organization: 'London Basketball Academy' },
        { quote: 'تواصل ممتاز من البداية إلى النهاية. أجابوا على جميع أسئلتنا وجعلوا العملية بأكملها سلسة وخالية من الإجهاد.', name: 'Sarah Thompson', organization: 'Manchester Swimming Club' },
        { quote: 'ردود سريعة وخدمة احترافية واهتمام كبير بالتفاصيل. أوصي بشدة لأي فريق يخطط لمعسكر تدريب في بلغاريا.', name: 'Andreas Mueller', organization: 'Berlin Volleyball Team' },
      ],
    },
    cta: {
      heading: 'مستعد للبدء في التخطيط؟',
      text: 'لنخلق تجربة تدريب استثنائية لفريقك',
      viewPackages: 'عرض باقاتنا',
      scheduleCall: 'حجز مكالمة',
    },
  },
};
